<template>
  <v-container class="appclick">
    <v-row>
      <v-col class="col-6">
        <ImageTrack
          ref="ImageTrack"
          :obj="object.obj"
          :frame="object.frame"
          :mapid="map1"
        />
        <pagination
          class="pagination col-xs-12"
          v-model="o_slider"
          :total-page="n_objects"
          boundary-links
          pills
          @change="changeObject(o_slider)"
        />
        <font-awesome-icon
          :icon="icon"
          class="confirm_green"
          @click="confirm"
        />
        {{ icon }} ------ Confirm, go to next.
      </v-col>
      <v-col class="col-6">
        <Player
          ref="RefPlayer"
          :first="object.frame_first"
          :last="object.frame_last"
          :fps="fields.field_fps"
          :video="fields.video"
        />
      </v-col>
    </v-row>
    <v-row
      v-for="item in classes.parents"
      :key="item.parent_id"
      class="row-dense classification-row"
    >
      <v-col class="col-3 col-dense">
        <input
          type="radio"
          :id="item.parent_id"
          v-model="object.class_id"
          :value="item.parent_id"
          @change="change1()"
        /><label class="label-dense" :for="item.parent_id">
          <font-awesome-icon :icon="item.icon" /> {{ item.label }}</label
        >
      </v-col>
      <span v-for="item2 in classes.childs[item.parent_id]" :key="item2.id">
        <v-col class="col-dense">
          <input
            type="radio"
            v-model="object.class_subclass_id"
            :value="item2.child_id"
            @change="change2(item2)"
          />
          {{ item2.label }}
        </v-col>
      </span>
    </v-row>
  </v-container>
</template>
<script>
import ImageTrack from "@/components/ImageTrack.vue";
import Player from "@/components/Player.vue";
import ProjectService from "@/services/ProjectService.js";
export default {
  components: {
    Player,
    ImageTrack
  },
  data: function() {
    return {
      objects: {},
      obj: 0,
      map2: "M2",
      map1: "M1",
      frame: 0,
      map12345: null,
      object: {},
      fields: {},
      classes: {},
      n_objects: 0,
      o_slider: 1,
      starttijd: 60,
      duur: 120,
      video: "",
      icon: "car"
    };
  },
  created() {
    let vars = { class: this.$route.params };
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "correct_class_test",
      vars
    })
      .then(response => {
        this.classes = response.data.classes;
        this.n_objects = response.data.n;
        this.objects = response.data.objects;
        this.fields = response.data.fields;
        this.o_slider = 1;
        this.object = this.objects[1];
        console.log(this.object);
        this.icon = this.classes.parents_icon[this.object.class_id];
        this.changeObject(1);
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
    //this.changeObject(1);
  },
  methods: {
    changeObject(o_slider) {
      this.object = this.objects[o_slider];
    },
    confirm() {
      let vars = {
        obj: this.object.obj,
        class: this.object.class_id,
        subclass: this.object.class_subclass_id
      };
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "correct_class",
        vars
      });
      this.o_slider++;
      this.changeObject(this.o_slider);
    },
    change1() {
      console.log(this.object);
      console.log(this.object.class_id);
      this.icon = this.classes.parents_icon[this.object.class_id];
      this.object.class_subclass_id = 0;
    },
    change2() {
      let parent = this.classes.child_to_parent[this.object.class_subclass_id];
      if (parent > 0) {
        this.object.class_id = parent;
      }
    },
    callPlayer() {
      this.$refs.RefPlayer.StartVideo(
        this.object.frame_first,
        this.object.frame_last
      );
    },
    test() {
      this.starttijd = 120;
    }
  }
};
</script>

<style scoped>
.col-dense,
.col-3,
.col-1 {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.classification-row {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.row-dense {
  border-top-width: thin;
  border-top-style: solid;
  border-top-color: #55d4ff;
}

.map {
  height: 420px;
  width: 630px;
}

button {
  margin-left: 10px;
  font-size: 10px;
}

h6 {
  height: 30px;
}
.label-dense,
label {
  display: inline !important;
}

.confirm_green {
  color: green;
  margin-left: 20px;
  font-size: 350% !important;
}
.confirm_green .title {
  margin: 15px;
}

.pagination {
  display: inline-block !important;
}
</style>
